var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#575757"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7188 8.53125H15.8594L15.4164 7.28984C15.3858 7.2049 15.3297 7.13147 15.2558 7.07959C15.1819 7.02772 15.0938 6.99992 15.0035 7H10.809C10.6244 7 10.459 7.11621 10.3975 7.28984L9.95312 8.53125H8.09375C7.48945 8.53125 7 9.0207 7 9.625V15.8594C7 16.4637 7.48945 16.9531 8.09375 16.9531H17.7188C18.323 16.9531 18.8125 16.4637 18.8125 15.8594V9.625C18.8125 9.0207 18.323 8.53125 17.7188 8.53125ZM12.9062 14.7656C11.6977 14.7656 10.7188 13.7867 10.7188 12.5781C10.7188 11.3695 11.6977 10.3906 12.9062 10.3906C14.1148 10.3906 15.0938 11.3695 15.0938 12.5781C15.0938 13.7867 14.1148 14.7656 12.9062 14.7656ZM11.5938 12.5781C11.5938 12.9262 11.732 13.2601 11.9782 13.5062C12.2243 13.7523 12.5582 13.8906 12.9062 13.8906C13.2543 13.8906 13.5882 13.7523 13.8343 13.5062C14.0805 13.2601 14.2188 12.9262 14.2188 12.5781C14.2188 12.23 14.0805 11.8962 13.8343 11.65C13.5882 11.4039 13.2543 11.2656 12.9062 11.2656C12.5582 11.2656 12.2243 11.4039 11.9782 11.65C11.732 11.8962 11.5938 12.23 11.5938 12.5781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.39fd3063aa0b3085f3e03e4329ad0a50.svg";
export { ForwardRef as ReactComponent };